(() => {
  if (window.mimoriProtectionInstalled) return;
  window.mimoriProtectionInstalled = true;
  const sectionNames = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  const root = () => window.Shopify?.routes?.root || '/';
  let busy = false;

  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-mimori-cart-extras]').forEach((box) => {
      const checkbox = box.querySelector('[data-mimori-shipping-toggle]');
      if (value) box.setAttribute('data-mimori-pending', '');
      else box.removeAttribute('data-mimori-pending');
      if (checkbox) checkbox.disabled = value;
    });
  }

  function updateHtml(sections) {
    if (!sections || typeof sections !== 'object') return false;
    let updated = false;
    for (const [id, html] of Object.entries(sections)) {
      if (typeof html !== 'string' || !html) continue;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const current = document.getElementById('CartDrawer');
        const fresh = parsed.getElementById('CartDrawer');
        if (current && fresh) { current.innerHTML = fresh.innerHTML; updated = true; }
      } else {
        const current = document.getElementById('shopify-section-' + id) || document.getElementById(id);
        if (!current) continue;
        const fresh = parsed.getElementById(current.id);
        if (fresh) { current.innerHTML = fresh.innerHTML; updated = true; }
      }
    }
    return updated;
  }

  async function readCart() {
    const response = await fetch(root() + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to read your cart.');
    return response.json();
  }

  async function sendChange(path, payload) {
    const response = await fetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ ...payload, sections: sectionNames, sections_url: window.location.pathname })
    });
    if (!response.ok) {
      const data = await response.json().catch(() => null);
      throw new Error(data?.description || data?.message || 'Please try again.');
    }
    return response.json();
  }

  document.addEventListener('change', async (event) => {
    const input = event.target.closest?.('[data-mimori-shipping-toggle]');
    if (!input || busy) return;
    const wanted = input.checked;
    const variantId = Number(input.closest('[data-mimori-cart-extras]')?.dataset.protectionId);
    if (!variantId) return;
    setBusy(true);
    document.querySelectorAll('[data-mimori-shipping-error]').forEach((error) => { error.hidden = true; error.textContent = ''; });
    try {
      const cart = await readCart();
      const protection = cart.items.find((line) => Number(line.variant_id) === variantId);
      let response;
      if (wanted && !protection) {
        response = await sendChange('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      } else if (!wanted && protection) {
        response = await sendChange('cart/change.js', { id: protection.key, quantity: 0 });
      } else {
        return;
      }
      if (!updateHtml(response.sections)) {
        const fresh = await fetch(root() + '?sections=' + sectionNames.join(','), { credentials: 'same-origin' });
        if (fresh.ok) updateHtml(await fresh.json());
      }
      const current = await readCart();
      const currentlyAdded = current.items.some((line) => Number(line.variant_id) === variantId);
      document.querySelectorAll('[data-mimori-shipping-toggle]').forEach((toggle) => {
        toggle.checked = currentlyAdded;
      });
    } catch (error) {
      document.querySelectorAll('[data-mimori-shipping-toggle]').forEach((toggle) => { toggle.checked = !wanted; });
      document.querySelectorAll('[data-mimori-shipping-error]').forEach((label) => {
        label.textContent = error.message || 'Unable to update your order. Please try again.';
        label.hidden = false;
      });
    } finally {
      setBusy(false);
    }
  });

  document.addEventListener('click', (event) => {
    if (busy && event.target.closest?.('#CartDrawer-Checkout, #checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
